const homolog = false
const api =  homolog ? 'https://192.168.1.58:3001/api/store' : 'https://api.allon.cloud/api/store'
const image_api = homolog ? 'https://localhost:8443' : 'https://allon.store'

export { api , image_api }